export default __webpack_public_path__ + "static/media/shutterstock_1681965871-2.819b72b9.webp";